import {Directive, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {School} from '../../schools/school/school';
import {Province} from '../../provinces/province/province';
import {SchoolsService} from '../../schools/schools.service';
import {Results} from '../../../core/results';
import {SubFunder} from './sub-funder';
import {SubFundersService} from '../sub-funders.service';
declare var $: any;
@Directive({
  selector: '[appSubFunder]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SubFunderDirective),
    multi: true
  }]
})
export class SubFunderDirective implements ControlValueAccessor, OnInit {

  @Input() private subFunder: SubFunder;
  @Input() private disabled = false;
  @Input() private title;
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  select2: any;

  constructor(private el: ElementRef, private service: SubFundersService) {
  }

  ngOnInit(): void {
    const that = this;
    this.select2 = $(this.el.nativeElement).select2({
      width: '100%',
      placeholder: that.title?that.title:'Select Sub Funder',
      allowClear: true,
      ajax: {
        transport: function(params, success, failure) {
          const page = 1;
          const perPage = 10;
          that.service.search(page, perPage, 'ASC', 'name', params.data.term).subscribe((ret: Results<School>) => {
            success(ret);
          });
        },
        dataType: 'json',
        type: 'GET',
        processResults: function(data) {
          const arr = [];
          data.content.forEach(function(obj) {
            arr.push({
              id: JSON.stringify(obj),
              text: obj.name,
            });
          });
          return {
            results: arr
          };
        }
      }
    });
    $(this.el.nativeElement).on('select2:select', function(e) {

      that.subFunder = JSON.parse(e.params.data.id);
      that.propagateChange(that.subFunder);
      if(that.onSelect) {
        that.onSelect.emit();
      }

    });

    $(this.el.nativeElement).on('select2:unselect', function(e) {

      that.subFunder = null;
      that.propagateChange(that.subFunder);
      if(that.onSelect) {
        that.onSelect.emit();
      }
    });


  }

  onTouched = () => {
  };

  propagateChange = (_: any) => {
  };

  writeValue(subFunder: SubFunder): void {

    this.subFunder = subFunder;
    this.propagateChange(this.subFunder);
    const that = this;
    if (this.subFunder !== undefined && this.subFunder !== null) {
      const option = new Option(subFunder.name, JSON.stringify(subFunder), true, true);
      that.select2.append(option);
      that.select2.trigger('change');
    }else {
      const option = new Option('', '', true, true);
      that.select2.append(option);
      that.select2.trigger('change');
    }

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get value(): any {
    return this.subFunder;
  }

  set value(v: any) {
    if (v !== this.subFunder) {
      this.subFunder = v;
      this.propagateChange(v);
    }
  }

}
